import { TradingPane } from '../types'
import {
  SetAmount,
  InputAmount,
  SetTakeProfit,
  SetStopLoss,
  SetTradeType,
  SetPrice,
} from '../actions/TradeActions'
import {
  SET_TRADE_TYPE,
  SET_AMOUNT,
  INPUT_AMOUNT,
  SET_TAKEPROFIT,
  SET_STOPLOSS,
  REFRESH_TRADING_VALUES,
  UPDATE_TRADING_VALUES,
  CLEAR_STATE,
  APPLY_POST_COMMAND,
  SET_PRICE,
  INPUT_POSITION_PRICE,
  INPUT_POSITION_STOPLOSS,
  INPUT_POSITION_TAKEPROFIT,
  SET_TRADING_SYMBOL,
} from '../constants'
import { RefreshAccountValues, TradingAction } from '../actions'
import {
  ApplyPostCommand,
  ClearState,
  DisableTradeControls,
  EnableTradeControls,
  RefreshTradingValues,
  SetTradingSymbol,
  UpdateTradingValues,
} from '../actions/commonActions'
import { DISABLE_TRADE_CONTROLS, ENABLE_TRADE_CONTROLS } from '../constants/modal-const'

export const initialTradingPanel: TradingPane = {
  lotsInitial: 0,
  lots: 0,
  lotsInput: 0,
  amountInitial: 0,
  amount: 0,
  amountInput: 0,
  tradeType: 'sell',
  tradeOperationEnabled: false,
  buy: {
    value: 0,
    valueAccount: 0,
    requiredMargin: 0,
    requiredMarginAccount: 0,
    takeProfitEnabled: false,
    takeProfitInitial: 0,
    takeProfit: 0,
    profit: 0,
    profitPercent: 0,
    stopLossEnabled: false,
    stopLossInitial: 0,
    stopLoss: 0,
    loss: 0,
    lossPercent: 0,
    pendingOrderEnabled: false,
    priceInitial: 0,
    price: 0,
  },
  sell: {
    value: 0,
    valueAccount: 0,
    requiredMargin: 0,
    requiredMarginAccount: 0,
    takeProfitEnabled: false,
    takeProfitInitial: 0,
    takeProfit: 0,
    profit: 0,
    profitPercent: 0,
    stopLossEnabled: false,
    stopLossInitial: 0,
    stopLoss: 0,
    loss: 0,
    lossPercent: 0,
    pendingOrderEnabled: false,
    priceInitial: 0,
    price: 0,
  },
}

export function tradingPane(
  state: TradingPane = { ...initialTradingPanel },
  action:
    | SetAmount
    | SetTakeProfit
    | SetStopLoss
    | SetPrice
    | SetTradeType
    | RefreshAccountValues
    | RefreshTradingValues
    | UpdateTradingValues
    | DisableTradeControls
    | ApplyPostCommand
    | EnableTradeControls
    | ClearState
    | SetTradingSymbol
    | TradingAction
    | InputAmount
): TradingPane {
  switch (action.type) {
    case CLEAR_STATE:
      return { ...initialTradingPanel }
    case SET_TRADE_TYPE:
      return { ...state, tradeType: action.tradeType }
    case SET_TRADING_SYMBOL:
      return { ...state, tradeType: action.tradeType }
    case SET_AMOUNT:
      return { ...state, amount: action.amount, amountInput: action.amount }
    case INPUT_AMOUNT:
      return { ...state, amountInput: action.amount }
    case APPLY_POST_COMMAND: {
      const { tradeType: type, takeProfit, stopLoss } = action
      const newTradeState = {
        ...state[type],
        takeProfitEnabled: !!takeProfit,
        stopLossEnabled: !!stopLoss,
      }
      if (takeProfit) {
        newTradeState.takeProfit = takeProfit
      }
      if (stopLoss) {
        newTradeState.stopLoss = stopLoss
      }
      return {
        ...state,
        tradeType: type,
        [type]: newTradeState,
      }
    }
    case SET_TAKEPROFIT:
      return {
        ...state,
        [state.tradeType]: {
          ...state[state.tradeType],
          takeProfit: action.takeProfit,
          takeProfitEnabled: action.takeProfit !== 0,
        },
      }
    case SET_STOPLOSS:
      return {
        ...state,
        [state.tradeType]: {
          ...state[state.tradeType],
          stopLoss: action.stopLoss,
          stopLossEnabled: action.stopLoss !== 0,
        },
      }
    case SET_PRICE:
      return {
        ...state,
        [state.tradeType]: {
          ...state[state.tradeType],
          price: action.price,
          pendingOrderEnabled: action.price !== 0,
        },
      }
    case DISABLE_TRADE_CONTROLS: {
      return { ...state, tradeOperationEnabled: false }
    }
    case ENABLE_TRADE_CONTROLS: {
      return { ...state, tradeOperationEnabled: true }
    }
    case REFRESH_TRADING_VALUES: {
      const {
        amount,
        amountInitial,
        amountInput,
        lots,
        lotsInitial,
        lotsInput,
        buy,
        sell,
      } = action as RefreshTradingValues
      return {
        ...state,
        amount,
        amountInitial,
        amountInput,
        lots,
        lotsInitial,
        lotsInput,
        buy: { ...buy },
        sell: { ...sell },
      }
    }
    case UPDATE_TRADING_VALUES: {
      const { amountInitial, lotsInitial, buy, sell, lots } = action as UpdateTradingValues
      return {
        ...state,
        amountInitial,
        lotsInitial,
        lots,
        buy: { ...state.buy, ...buy },
        sell: { ...state.sell, ...sell },
      }
    }
    case INPUT_POSITION_PRICE: {
      return action.order < 0
        ? {
            ...state,
            [state.tradeType]: {
              ...state[state.tradeType],
              price: action.price,
              pendingOrderEnabled: action.price !== 0,
            },
          }
        : { ...state }
    }
    case INPUT_POSITION_STOPLOSS: {
      return action.order < 0
        ? {
            ...state,
            [state.tradeType]: {
              ...state[state.tradeType],
              stopLoss: action.stopLoss,
              stopLossEnabled: action.stopLoss !== 0,
            },
          }
        : { ...state }
    }
    case INPUT_POSITION_TAKEPROFIT: {
      return action.order < 0
        ? {
            ...state,
            [state.tradeType]: {
              ...state[state.tradeType],
              takeProfit: action.takeProfit,
              takeProfitEnabled: action.takeProfit !== 0,
            },
          }
        : { ...state }
    }
    default:
      return { ...state }
  }
}
